import { Button, Modal, Space, message } from 'antd';
import React from 'react';
import { useDrawerVisibility } from '../../../../../shared/hooks/useDrawerVisibility';
import { useFieldIdWhichWillBeUpdated } from '../../../../../shared/hooks/useFieldIdWhichWillBeUpdated';

export const TableActionColumn = ({ onDeleteButtonClick, payloadOfFieldWhichWillBeUpdated, editDrawerVisibility, deleteTitle }) => {
  const [setDrawerVisibility] = useDrawerVisibility();
  const [setFieldIdWhichWillBeUpdated] = useFieldIdWhichWillBeUpdated();

  const handleEditButtonClick = () => {
    setFieldIdWhichWillBeUpdated(payloadOfFieldWhichWillBeUpdated);
    setDrawerVisibility(editDrawerVisibility);
  };

  const handleDeleteButtonClick = () => Modal.confirm({
    title: deleteTitle || 'Удалить запись?',
    content: 'Отменить удаление будет нельзя.',
    okText: 'Удалить',
    okButtonProps: { danger: true },
    cancelText: 'Отмена',
    onOk: async () => {
      try {
        await onDeleteButtonClick();
        window.location.reload();
      } catch (err) {
        message.error('Не удалось удалить');
      }
    },
  });

  return (
    <Space size="middle">
      <Button onClick={handleEditButtonClick}>Изменить</Button>
      <Button danger onClick={handleDeleteButtonClick}>Удалить</Button>
    </Space>
  );
};
